import html from "html-literal";

export default () => html`
  <footer>
    &copy; 2020 <a href="https://savvycoders.com/">Savvy Coders</a>
  </footer>
`;
